export default __webpack_public_path__ + "static/media/060_corner2.last.93bff106.webp";